import React from 'react';

import {
    Button,
    Icon,
    View,
    colors,
    Grid,
    useViewport,
} from '@fairygodboss/ui';

import AuthWrapperComponent from '../../../CallToAction/AuthWrapperComponent/AuthWrapperComponent';
import { useJobSearchContext } from '../../../../contexts/JobSearchContext';

export const ApplyButtonGroup = ({
    handleCompanyApplyClick,
    handleSaveClick,
    isSaved,
    position,
    applyButtonText = 'Apply on company site',
    showDirectApply,
    handleQuickApplyClick,
}) => {
    const { hasApplied } = useJobSearchContext();
    const QuickApplyText = hasApplied ? 'Applied' : 'Quick Apply';
    const buttonText = showDirectApply ? QuickApplyText : applyButtonText;
    const applyClickHandler = showDirectApply
        ? handleQuickApplyClick
        : handleCompanyApplyClick;
    const { isSM } = useViewport();
    return (
        <View
            width="100%"
            css={{
                '@media screen and (min-width: 360px)': {
                    maxWidth: '548px',
                },
                '@media screen and (max-width: 605px)': {
                    width: '100%',
                    alignItems: 'center',
                    flexDirection: 'column',
                    flexGrow: '1',
                    div: {
                        alignSelf: 'stretch',
                        width: 'auto',
                    },
                    button: {
                        marginRight: '5px!important',
                    },
                },
            }}
        >
            <Grid>
                <Button
                    data-qa={`Jobs-apply-button${
                        position ? `-${position}` : ''
                    }`}
                    size="medium"
                    mr={{ _: '16px' }}
                    mt={{ _: '2px' }}
                    pl={{ _: '8px', md: '16px' }}
                    pr={{ _: '8px', md: '16px' }}
                    height={{ _: '42px' }}
                    top="-2px"
                    disabled={hasApplied}
                    width={{
                        _: 'calc((100% * 2/3) - 42px)',
                        md: applyButtonText === 'Apply' ? '120px' : '190px',
                    }}
                    minWidth={{
                        _: 'calc((100% * 2/3) - 42px)',
                        md: applyButtonText === 'Apply' ? '120px' : '190px',
                    }}
                    onPress={() => {
                        if (applyClickHandler) {
                            applyClickHandler(position);
                        }
                    }}
                >
                    {buttonText}
                </Button>
                <AuthWrapperComponent
                    callToActionHash="save-job"
                    loginTrigger="save-job"
                >
                    <Button
                        data-qa={`Jobs-save-button${
                            position ? `-${position}` : ''
                        }`}
                        onPress={() => {
                            if (handleSaveClick) {
                                handleSaveClick(position);
                            }
                        }}
                        minWidth="95px"
                        width={{
                            _: 'calc((100% * 1/3) + 32px)',
                            md: applyButtonText === 'Apply' ? '55px' : '178px',
                        }}
                        height={{ _: '42px' }}
                        leftIcon={
                            !isSaved ? (
                                <Icon
                                    variant="heartOutline_16"
                                    outlineColor={colors.secondary[70]}
                                />
                            ) : (
                                <Icon
                                    variant="heartFilled_16"
                                    outlineColor={colors.secondary[70]}
                                    fillColor={colors.secondary[70]}
                                />
                            )
                        }
                        size="medium"
                        variant="secondary"
                    >
                        {applyButtonText === 'Apply' || !isSM
                            ? 'Save'
                            : 'Save for later'}
                    </Button>
                </AuthWrapperComponent>
            </Grid>
        </View>
    );
};
